@if (formToValidate && validationMessages) {
  <ul class="parsley-errors-list filled">
    @for (validation of validationMessages; track validation) {
      @if (debugMode) {
        <li> {{validation.type}}</li>
      }
      @if (hasError(validation.type) === true && isTouched() === true) {
        <li>{{validation.message}}</li>
      }
    }
  </ul>
}
